module.exports = __webpack_public_path__ + "img/zxfCode.35d01511.jpg";